<template>
  <div v-if="!loading" class="justify-content-center w-100">
    <b-container fluid class="max-width py-4">
      <div class="row justify-content-center">
        <div class="col-12">
          <h2 class="mt-3 mb-5 border-bottom">
            {{ trans("home.title.first", { username: userFirstName }) }}
          </h2>
        </div>
      </div>

      <div v-if="components.nextStep" class="next-unit-wrapper">
        <next-learning-unit-container />
      </div>

      <div class="row justify-content-center onboarding-wrapper" v-if="onboardingVisible">
        <div
          class="col-12 px-0"
          v-observe-visibility="{
            callback: (isVisible) => visibilityChanged(isVisible, `onboarding`),
            once: true,
            throttle: 300,
          }"
        >
          <on-boarding-panel
            v-if="lazyLoad.onboarding"
            @onHide="updateComponentState('onboarding', false)"
          />
        </div>
      </div>

      <div id="path">
        <div
          class="row justify-content-center mb-5 active-services-wrapper"
          v-if="components.activeServices"
        >
          <div
            class="col-12"
            v-observe-visibility="{
              callback: (isVisible) => visibilityChanged(isVisible, `activeServices`),
              once: true,
              throttle: 300,
            }"
          >
            <h4 class="h4 mb-4">{{ trans("home.mastersHighlight") }}</h4>

            <active-services v-if="lazyLoad.activeServices" />
          </div>
        </div>

        <div v-if="components.availableServices" class="available-services-wrapper">
          <div
            v-observe-visibility="{
              callback: (isVisible) => visibilityChanged(isVisible, `availableServices`),
              once: true,
              throttle: 300,
            }"
          >
            <service-list
              v-if="lazyLoad.availableServices"
              :title="trans('home.services.title')"
              mount-location="Home"
            />
          </div>
        </div>
      </div>
    </b-container>
    <div class="mt-3 tools-container w-100">
      <b-container fluid class="py-4 pt-5 max-width">
        <div class="row mb-4 justify-content-center">
          <div class="col-12 col-md-10">
            <h5 class="text-primary">{{ trans("home.tools") }}</h5>
            <p>{{ trans("home.tools_description") }}</p>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-12 col-md-10">
            <div>
              <div class="row justify-content-center">
                <div
                  class="col-md-6 mb-4"
                  v-if="components.multime"
                  v-observe-visibility="{
                    callback: (isVisible) => visibilityChanged(isVisible, `multimeAndTransitions`),
                    once: true,
                    throttle: 300,
                  }"
                >
                  <multime-widget v-if="lazyLoad.multimeAndTransitions" />
                </div>
                <div
                  class="col-md-6 mb-4"
                  v-observe-visibility="{
                    callback: (isVisible) => visibilityChanged(isVisible, `multimeAndTransitions`),
                    once: true,
                    throttle: 300,
                  }"
                >
                  <life-transitions-widget
                    :has-transitions="components.lifeTransitions"
                    v-if="lazyLoad.multimeAndTransitions"
                  />
                </div>
              </div>
            </div>

            <div
              class="d-flex w-100"
              v-if="components.hrDashboard"
              v-observe-visibility="{
                callback: (isVisible) => visibilityChanged(isVisible, `companyDashboard`),
                once: true,
                throttle: 300,
              }"
            >
              <company-dashboard v-if="lazyLoad.companyDashboard" />
            </div>

            <div class="row mb-3" v-if="components.become360">
              <div class="col-12">
                <text-image-card
                  :title="trans('courses.new_dashboard.become_360')"
                  :description="trans('courses.new_dashboard.become_360_desk')"
                  illustration="/images/illustrations/become360_small.svg"
                  logoImage="/images/illustrations/caforscari_badge.svg"
                  :buttonText="trans('home.explore')"
                  buttonHref="/assessments"
                />
              </div>
            </div>
          </div>
        </div>
      </b-container>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import TextImageCard from "../molecules/cards/TextImageCard";
import OnBoardingPanel from "../organisms/onboarding/OnBoardingPanel";
import NextLearningUnitContainer from "../organisms/widgets/next-learning-unit/NextLearningUnitContainer";
import MultimeWidget from "../organisms/widgets/multime/MultimeWidget";
import LifeTransitionsWidget from "../organisms/widgets/LifeTransitionsWidget";
import ActiveServices from "../organisms/widgets/ActiveServices";
import CompanyDashboard from "../organisms/widgets/CompanyDashboard";
import ServiceList from "../organisms/ServiceList";

export default {
  name: "HomePage",
  components: {
    TextImageCard,
    CompanyDashboard,
    OnBoardingPanel,
    NextLearningUnitContainer,
    ServiceList,
    MultimeWidget,
    LifeTransitionsWidget,
    ActiveServices,
  },
  data() {
    return {
      loading: true,
      components: {},
      lazyLoad: {
        onboarding: false,
        availableServices: false,
        multimeAndTransitions: false,
        activeServices: false,
        companyDashboard: false,
      },
    };
  },
  mounted() {
    trackEvent("ServiceDashboard", {});

    this.$axios
      .get("/api/rest/home")
      .then((res) => {
        this.loading = false;
        this.components = res.data;
      })
      .catch((err) => {
        this.loading = false;
        console.log(err);
      });
  },
  computed: {
    ...mapGetters({
      userFirstName: "user/getUserFirstname",
    }),
    onboardingVisible() {
      return this.components.onboarding && !localStorage.getItem("onboardingPanelIsHidden");
    },
  },
  methods: {
    visibilityChanged(isVisible, item) {
      this.lazyLoad[item] = isVisible;
    },
    updateComponentState(key, state) {
      this.components[key] = state;
    },
  },
};
</script>

<style scoped lang="scss">
.tools-container {
  background-color: $color-light;
}

.next-unit-wrapper {
  min-height: 300px;
}

.onboarding-wrapper {
  min-height: 460px;
}

.active-services-wrapper {
  min-height: 250px;
}

.available-services-wrapper {
  min-height: 400px;
}
</style>
